/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::095fafc74fcbafa5e8b41c493c2b6af3>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Target".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/target
 * Usage guidance:
 * Single purpose - Reserved for targets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const TargetIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "TargetIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.543 7.25H4v1.5H1.543a6.5 6.5 0 0 0 5.707 5.707V12h1.5v2.457a6.5 6.5 0 0 0 5.707-5.707H12v-1.5h2.457A6.5 6.5 0 0 0 8.75 1.543V4h-1.5V1.543A6.5 6.5 0 0 0 1.543 7.25M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
TargetIcon.displayName = 'TargetIcon';
var _default = exports.default = TargetIcon;